export default __webpack_public_path__ + "static/media/institute-24-min.38918a13.webp";